import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Fade,
} from '@mui/material';
import { useLanguage } from '../context/LanguageContext';

const PrivacyPage = () => {
  const { t } = useLanguage();

  return (
    <Box sx={{ py: { xs: 4, md: 8 }, bgcolor: 'background.default' }}>
      <Container maxWidth="md">
        <Fade in timeout={800}>
          <Box>
            <Typography
              variant="h1"
              sx={{
                mb: 2,
                textAlign: 'center',
                fontSize: { xs: '2.5rem', md: '3rem' },
                color: 'primary.main',
              }}
            >
              {t.privacyTitle}
            </Typography>
            <Typography
              variant="body1"
              sx={{ mb: 6, textAlign: 'center', color: 'text.secondary' }}
            >
              {t.privacyLastUpdated}
            </Typography>

            <Paper
              elevation={0}
              sx={{
                p: { xs: 3, md: 4 },
                bgcolor: 'background.paper',
                border: '1px solid rgba(0,0,0,0.08)',
              }}
            >
              {t.privacyContent.map((section, index) => (
                <Fade in timeout={800 + index * 150} key={index}>
                  <Box sx={{ mb: 4 }}>
                    <Typography
                      variant="h4"
                      sx={{ mb: 2, color: 'primary.main', fontWeight: 600 }}
                    >
                      {section.heading}
                    </Typography>
                    <Typography variant="body1" sx={{ lineHeight: 1.7, color: 'text.primary' }}>
                      {section.body}
                      {index === t.privacyContent.length - 1 && (
                        <>
                          {' '}
                          <a href="mailto:tzhao@curateddata.ai" style={{ color: '#22336c' }}>
                            tzhao@curateddata.ai
                          </a>.
                        </>
                      )}
                    </Typography>
                  </Box>
                </Fade>
              ))}
            </Paper>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default PrivacyPage;
